module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.shiftCanceled) ? _c('div', {
    staticClass: "shift"
  }, [_c('div', {
    staticClass: "shift-name"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.shift.real_start, 'HH:mm')) + " - ")]), _c('strong', {
    staticClass: "type"
  }, [_vm._v(_vm._s(_vm.shift.shift_type))])]), (_vm.shift.shift_manager) ? _c('div', {
    staticClass: "manager"
  }, [_c('strong', [_vm._v("AL: " + _vm._s(_vm.shift.shift_manager))])]) : _vm._e(), _c('div', {
    staticClass: "employees"
  }, _vm._l((_vm.shift.employees), function(employee) {
    return _c('span', {
      staticClass: "employee"
    }, [_vm._v(_vm._s(employee))])
  }), 0), (_vm.shift.comments !== '') ? _c('div', {
    staticClass: "comments",
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.linebreaks(_vm.shift.comments))
    }
  }) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5169af48"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shift.vue
// module id = 1085
// module chunks = 1